import Vue from 'vue';
import moment from 'moment';

// You can set the locale globally if needed
moment.locale('en');

// Add moment to the Vue prototype
Vue.prototype.$moment = moment;